import { render, staticRenderFns } from "./CampaignUnpf.vue?vue&type=template&id=5677e3cb&"
import script from "./CampaignUnpf.vue?vue&type=script&lang=js&"
export * from "./CampaignUnpf.vue?vue&type=script&lang=js&"
import style0 from "./CampaignUnpf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports